import React, { ReactNode } from "react";
import styles from "./styles.module.css";
import { ReactComponent as LogoSvg } from "../../../assets/altlogo.svg";
import { ReactComponent as CBNLogoSvg } from "../../../assets/CBNLOGO.svg";
import { ReactComponent as TABLogoSvg } from "../../../assets/TABLOGO.svg";
import { ReactComponent as TABLogoAltSvg } from "../../../assets/TABLOGOALT.svg";
import useMediaQuery from "../../../app/common/hooks/useMediaQuery";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
interface Props {
  children: ReactNode;
}
const UnAuthorizedLayout = ({ children }: Props) => {
  const matches = useMediaQuery("(min-width: 800px)");
  const navigate = useNavigate();
  return (
    <div className={styles.origin}>
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          {/* <img
          src={altlogo}
          style={{
            width: matches ? "150px" : "150px",
            marginLeft: matches ? "-45px" : "5px",
            cursor:"pointer"
          }}
          alt="logo"
          onClick={() => navigate('/') }
        /> */}
          <LogoSvg
            style={{
              width: matches ? "150px" : "150px",
              marginLeft: matches ? "-45px" : "5px",
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          />
        </div>
        <div className={styles.banner}>
          <div className={styles.bannerContainer}>
            {matches && (
              <div className={styles.subtext}>
                <div className={styles.firstColumn}>
                  <h2>Great to have you here!</h2>
                  <div>
                    {" "}
                    <p>You can login to access your Account.</p>
                  </div>
                  <>
                    <div className={styles.copyright}>
                      <span>
                        Licensed by Cental Bank Of Nigeria <CBNLogoSvg />
                      </span>
                      <span>|</span>
                      <span>Powered by</span>
                      <span>
                        <TABLogoSvg />
                      </span>
                    </div>
                  </>
                </div>
              </div>
            )}
            <div className={styles.childrenContainer}>{children}</div>
          </div>

          {/* {!matches && <div className={styles.childrenContainer}>{children}</div>} */}
        </div>
        {!matches && (
          <div className={styles.footer}>
            <div className={styles.copyright}>
              <span>
                Licensed by Cental Bank Of Nigeria <CBNLogoSvg />
              </span>
              <span>|</span>
              <span>Powered by</span>
              <span>
                <TABLogoAltSvg />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(UnAuthorizedLayout);
